import { render, staticRenderFns } from "./CreditosClientes.vue?vue&type=template&id=19210f2e"
import script from "./CreditosClientes.vue?vue&type=script&lang=js"
export * from "./CreditosClientes.vue?vue&type=script&lang=js"
import style0 from "../Tintometrico/tintometrico.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports